export class DialogModelCreateTicket {
    constructor(
        public response: any
    ) { }
}